<div class="sidebar pt-0 mx-md-1">
  <div class="text-center mb-3">
    <div id="profile-sidebar" class="d-inline-block">
      <div class="">
        <a [routerLink]="['/profile']">
          <img src="{{ user?.profile_image_url }}" src-fallback="{{ defaultprofileUrl }}" alt="" class="sidebar_user" style="border: 10px solid #f4f6fa;"/>
        </a>
      </div>
    </div>
  </div>
  <a [routerLink]="['/profile']">
    <h3 class="text-center user-title">{{ user?.name }}</h3>
  </a>
  @if (!other_user_id && user?.your_self) {
    <h4 class="text-blue text-center"><span class="feather icon-user"></span> {{ user?.your_self }}</h4>
  }
  @if (other_user_id && user?.user_connections && user?.user_connections?.status == 'approved') {
    <h4 class="text-blue text-center">
      <span class="feather icon-user"></span> {{ user?.user_connections?.relationship_type | slice: 0:16 }}
    </h4>
  }
  @if (other_user_id && user?.user_connections && user?.user_connections?.status == 'pending') {
    <div class="view-all text-center a-link-div">
      Request Pending
    </div>
  }
  @if (other_user_id && !user?.user_connections) {
    <div class="view-all text-center a-link-div">
      <a class="a-link" (click)="openConnectModal(user)">Send Request</a>
    </div>
  }
  <h3>NETWORK</h3>
  <table class="table">
    <tr>
      <td>
        <a [routerLink]="['/connection']" [state]="{ show: 'Existing' }" (click)="initiateConnectionFilter('Existing')">Network Connections</a>
      </td>
      <td>{{ connectionsCount }}</td>
    </tr>
    <tr>
      <td><a [routerLink]="['/connection']" [state]="{ show: 'Pending' }" (click)="initiateConnectionFilter('Pending')">Requests</a></td>
      <td>{{ pendingConnectionCount }}</td>
    </tr>
    <tr>
      <td><a [routerLink]="['/connection/suggestion']">Suggestions</a></td>
      <td>{{ suggestionsCount }}</td>
    </tr>
  </table>

  <!--your suggestion results-->
  <div>
    <suggestion miniView="true" suggestionsLimit="2" hideDefaultAddButton="true" hideMiniShowAll="true"></suggestion>
  </div>
  <!--your suggestion results-->
  @if (!other_user_id) {
    <button (click)="openInviteFriend()" class="invite my-3 py-1 mb-4 mt-3 w-100 d-flex justify-content-center align-items-center btn btnpost btnStyle suggestions" data-toggle="modal" data-target="#inviteUser">
      <span class="feather icon-user-plus mr-2 py-2"></span>
      <span> Invite User </span>
    </button>
  }
</div>
